import Vue from 'vue'

// State
const state = {
  isLoading: false,
  isSaving: false,
  selectedSign: null,
  data: []
}

const findIndex = (items, sign, variant) => {
  const signId = sign.id
  const variantId = variant.id
  return items.findIndex(
    ({ sign, variant }) => sign.id === signId && variant.id === variantId
  )
}
const upsert = (items, sign, variant, amount) => {
  const matchIndex = findIndex(state.data, sign, variant)
  // Already present
  if (matchIndex > -1) {
    return items.map((item, index) => {
      if (index === matchIndex) {
        return { ...item, amount: item.amount + amount }
      }
      return item
    })
  } else {
    // New
    return [...items, { sign, variant, amount }]
  }
}

// Mutations
export const selectSign = 'selectSign'
export const unselectSign = 'unselectSign'
export const addSign = 'addSign'
export const removeSign = 'removeSign'
export const updateSignAmount = 'updateSignAmount'
export const increaseSignAmount = 'increaseSignAmount'
export const decreaseSignAmount = 'decreaseSignAmount'

export const submitOrderRequest = 'submitOrderRequest'
export const submitOrderResponse = 'submitOrderResponse'
export const reset = 'reset'

const mutations = {
  [selectSign] (state, sign) {
    state.selectedSign = sign
  },
  [unselectSign] (state) {
    state.selectedSign = null
  },
  [addSign] (state, { sign, variant, amount }) {
    state.data = upsert(state.data, sign, variant, amount)
  },
  [updateSignAmount] (state, { sign, variant, amount }) {
    const matchIndex = findIndex(state.data, sign, variant)
    if (matchIndex > -1) {
      state.data = state.data.map((item, index) => {
        if (index === matchIndex) {
          return { ...item, amount }
        } else return item
      })
    }
  },
  [increaseSignAmount] (state, { sign, variant }) {
    state.data = upsert(state.data, sign, variant, 1)
  },
  [increaseSignAmount] (state, { sign, variant }) {
    state.data = upsert(state.data, sign, variant, -1)
  },
  [removeSign] (state, { sign, variant, amount }) {
    const matchIndex = findIndex(state.data, sign, variant)
    if (matchIndex > -1) {
      state.data = state.data.filter((item, index) => index !== matchIndex)
    }
  },
  [submitOrderRequest] (state) {
    state.isSaving = true
  },
  [submitOrderResponse] (state) {
    state.isSaving = false
  },
  [reset] (state) {
    state.data = []
  }
}

// Actions
export const submitOrder = 'submitOrder'
const actions = {
  [submitOrder]: ({ commit, dispatch }, order) => {
    commit(submitOrderRequest)
    return Vue.http.post(`${SERVER_URL}/sendOrder`, order).then(({ data }) => {
      commit(submitOrderResponse)
      commit(reset)
    })
  }
}

// Getters
const getters = {
  itemsInShoppingCart: state => {
    return state.data.reduce((sum, item) => sum + item.amount, 0)
  }
}

export default {
  getters,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/shopping-cart.js